import React from 'react';
import Isvg from 'react-inlinesvg';
import editIcon from '../../assets/edit.svg';
import garbageIcon from '../../assets/garbage.svg';
import DeleteModal from '../../components/deleteModal';
import Page from '../../containers/page';
import FormBuilder from '../../form-builder';
import { required } from '../../form-builder/validation';
import RouteComponent from '../../helpers/route';
import ListBuilder from '../../list-builder';


class Home extends RouteComponent {
    constructor(props) {
        super(props);
        this.state = {
            articlesList: true,
            articleForm: false,
            total: 20,
            items: [

            ],
            articleTypes: [],
            groups: [],
            subgroups: [],
            manufacturers: [],
            atc: [],
            shapes: [],
            modes: [],
            attributes: [],
            categories: []
        }
    }



    componentDidMount() {
        this._onLoad();

        this._api('categories', {}, (data) => {
            this.setState({ categories: data.categories })
        })

    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props[0].location.search != prevProps[0].location.search) {
            this._onLoad();
        }
    }

    render() {
        let params = this._getParams();

        console.log(this.state.categories)
        return (
            <div>
                <div className="section-title title-options">
                    <h1>{'Customers'.translate(this.props.lang)}</h1>
                </div>
                {this.state.articleForm ?
                    <div className="table-tabs">
                        <button onClick={() => this.setState({ articleForm: false })}>
                            {'Customers list'.translate(this.props.lamg)}
                        </button>
                        <button className="active" onClick={() => this.setState({ articleForm: {} })}>
                            {'Add new customer'.translate(this.props.lang)}
                        </button>
                    </div>
                    : null}

                {
                    this.state.articleForm ?

                        <div>
                            <div className="side-margin">
                                <FormBuilder
                                    registerSubmitAction={(submit) => this.submit = submit}
                                    classNameForm={"add-form-container"}
                                    // headerForm={"Artikal".translate(this.props.lang)}
                                    //                                  addButtonText={this.state.articleForm._id ? 'Edit product'.translate(this.props.lang) :  'Add new'.translate(this.props.lang)}
                                    lang={this.props.lang}
                                    onSubmit={(data) => {

                                        if (this.state.articleForm && this.state.articleForm._id) {
                                            console.log(data)
                                            this._api('api4', { data: data }, () => {
                                                this.setState({ articleForm: undefined }, () => { this._onLoad(); })
                                            });
                                        } else {
                                            console.log(data)
                                            this._api('api2', { data: data }, () => {
                                                this.setState({ articleForm: {} }, () => { this._onLoad() })
                                            });
                                        }
                                    }}
                                    initialValues={this.state.articleForm && this.state.articleForm._id ? this.state.articleForm : {}}
                                    fields={[
                                        {
                                            type: 'row',
                                            children: [
                                                {
                                                    type: 'col',
                                                    width: { lg: 12, sm: 12, xs: 12 },
                                                    children: [
                                                        {
                                                            type: 'block',
                                                            header: 'Account details'.translate(this.props.lang),
                                                            style: { paddingBottom: 33 },
                                                            children: [
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 4, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'text',
                                                                            name: 'username',
                                                                            next: 'password',
                                                                            label: 'Username',
                                                                            asyncValidation: true,
                                                                            validate: [
                                                                                required('Username is required!'),
                                                                                async (value) => {
                                                                                    try {
                                                                                        if (value) {
                                                                                            let res = await this._apiAsync('validate', { value: value, id: this.state.form ? this.state.form._id : null });
                                                                                            if (res.status == 400) {
                                                                                                return 'Username already in use'
                                                                                            }
                                                                                            return undefined;
                                                                                        }

                                                                                    } catch (e) {
                                                                                        return undefined;
                                                                                    }
                                                                                },
                                                                            ]
                                                                        },

                                                                    ]
                                                                },
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 4, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'text',
                                                                            name: 'password',
                                                                            label: 'Password',
                                                                            asyncValidation: true,
                                                                        },
                                                                    ]
                                                                },
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 4, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'text',
                                                                            name: 'email',
                                                                            label: 'EMail',
                                                                            asyncValidation: true,
                                                                            validate: [
                                                                                required('EMail is required!'),
                                                                            ]
                                                                        },
                                                                    ]
                                                                },

                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 4, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'text',
                                                                            name: 'customerData.id',
                                                                            label: 'Customer nr.',
                                                                        },
                                                                    ]
                                                                },
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 4, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'text',
                                                                            name: 'customerData.vatNumber',
                                                                            label: 'VAT',
                                                                        },
                                                                    ]
                                                                },
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 4, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'text',
                                                                            name: 'customerData.orgNumber',
                                                                            label: 'Organisation nr.',
                                                                        },
                                                                    ]
                                                                },
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 4, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'text',
                                                                            name: 'customerData.creditLimit',
                                                                            label: 'Limit',
                                                                        },
                                                                    ]
                                                                },
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 4, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'text',
                                                                            name: 'customerData.creditLimitCurrency',
                                                                            label: 'Currency',
                                                                        },
                                                                    ]
                                                                },
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 4, sm: 12, xs: 12 },
                                                                    children: [
                                                                    ]
                                                                },


                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 2, sm: 3, xs: 3 },
                                                                    children: [
                                                                        {
                                                                            type: 'switch',
                                                                            name: 'verified',
                                                                            next: 'stock',
                                                                            label: 'Verified',
                                                                        }
                                                                    ]
                                                                },
                                                                // {
                                                                //     type: 'col',
                                                                //     width: { lg: 2, sm: 3, xs: 3 },
                                                                //     children: [
                                                                //         {
                                                                //             type: 'switch',
                                                                //             name: 'emailVerified',
                                                                //             next: 'stock',
                                                                //             label: 'Verified',
                                                                //         }
                                                                //     ]
                                                                // },
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 3, sm: 3, xs: 3 },
                                                                    children: [
                                                                        {
                                                                            type: 'switch',
                                                                            name: 'newsletter',
                                                                            next: 'stock',
                                                                            label: 'Subcribed to newsletter',
                                                                        }
                                                                    ]
                                                                },




                                                            ]
                                                        },



                                                    ]
                                                },
                                                {
                                                    type: 'col',
                                                    width: { lg: 6, sm: 12, xs: 12 },
                                                    children: [
                                                        {
                                                            type: 'block',
                                                            header: 'Shipping data'.translate(this.props.lang),
                                                            style: { marginTop: 15, },
                                                            children: [
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 12, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'text',
                                                                            name: 'shippingData.firstName',
                                                                            label: 'First name',
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'shippingData.lastName',
                                                                            label: 'Last name',
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'shippingData.company',
                                                                            label: 'Company',
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'shippingData.email',
                                                                            label: 'EMail',
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'shippingData.address1',
                                                                            label: 'Address line 1',
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'shippingData.address2',
                                                                            label: 'Address line 1',
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'shippingData.city',
                                                                            label: 'City',
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'shippingData.state',
                                                                            label: 'State',
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'shippingData.phone',
                                                                            label: 'Phone',
                                                                        },

                                                                    ]
                                                                },
                                                            ]
                                                        },


                                                    ]
                                                },
                                                {
                                                    type: 'col',
                                                    width: { lg: 6, sm: 12, xs: 12 },
                                                    children: [
                                                        {
                                                            type: 'block',
                                                            header: 'Billing data'.translate(this.props.lang),
                                                            style: { marginTop: 15, },
                                                            children: [
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 12, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'text',
                                                                            name: 'billingData.firstName',
                                                                            label: 'First name',
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'billingData.lastName',
                                                                            label: 'Last name',
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'billingData.company',
                                                                            label: 'Company',
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'billingData.email',
                                                                            label: 'EMail',
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'billingData.address1',
                                                                            label: 'Address line 1',
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'billingData.address2',
                                                                            label: 'Address line 1',
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'billingData.city',
                                                                            label: 'City',
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'billingData.state',
                                                                            label: 'State',
                                                                        },
                                                                        {
                                                                            type: 'text',
                                                                            name: 'billingData.phone',
                                                                            label: 'Phone',
                                                                        },

                                                                    ]
                                                                },
                                                            ]
                                                        },


                                                    ]
                                                }








                                            ],
                                        },
                                        {
                                            type: 'row',
                                            children: [
                                                {
                                                    type: 'button',
                                                    width: { lg: 4, sm: 6, xs: 6 },
                                                    action: 'submit',
                                                    children: 'Save',
                                                    className: 'form-button',
                                                },

                                            ]
                                        }

                                    ]}
                                ></FormBuilder>
                            </div>

                        </div>

                        :

                        <div>
                            <DeleteModal
                                isOpen={this.state.deleteModal}
                                toggle={() => this.setState({ deleteModal: null })}
                                handler={() => {
                                    this._api('api3', { data: this.state.deleteModal._id }, () => {
                                        this.setState({ groupsForm: {} }, () => { this._onLoad(); this.setState({ deleteModal: null }) })
                                    });
                                }} >
                                {'Delete customer'.translate(this.props.lang)} <strong>{this.state.deleteModal ? this.state.deleteModal.name[this.props.lang] : ''}</strong> ?
                            </DeleteModal>
                            <ListBuilder
                                tabs={true}
                                sort={true}
                                tab1Name={'Customers list'.translate(this.props.lang)}
                                tab2Name={"Add new customer".translate(this.props.lang)}
                                onClickTab1={() => {
                                    this.setState({
                                        articlesList: true,
                                        articleForm: false,
                                    })
                                }}
                                onClickTab2={() => {
                                    this.setState({
                                        articleForm: true,
                                        articlesList: false
                                    })
                                }}
                                lang={this.props.lang}
                                loading={this.state.loading}
                                total={this.state.total}
                                showNumeration={false}
                                fields={[
                                    { type: 'text', name: 'customerData.id', label: 'CUSTOMER NR.'.translate(this.props.lang), multilang: false, allowSort: true },
                                    { type: 'text', name: 'username', label: 'USERNAME'.translate(this.props.lang), multilang: false, allowSort: true },
                                    { type: 'text', name: 'email', label: 'EMAIL'.translate(this.props.lang), multilang: false, allowSort: true },
                                    { type: 'text', name: 'customerData.vatNumber', label: 'VAT'.translate(this.props.lang), multilang: false, allowSort: true },

                                ]}
                                items={this.state.items}

                                actions={
                                    [
                                        {
                                            component: <Isvg src={editIcon} />,
                                            onClick: (item) => this.setState({ articleForm: item })
                                        },
                                        {
                                            component: <Isvg src={garbageIcon} />,
                                            onClick: (item) => this.setState({ deleteModal: item })
                                        },
                                    ]
                                }

                                params={params}
                                sortField={params.sortField}
                                sortType={params.sortType}
                                updateSort={this.updateSort}
                                updateParams={this.updateParams}
                                updateMultipleParams={this.updateMultipleParams}
                            ></ListBuilder>
                        </div>
                }


            </div>
        )
    }
}

export default Page(Home);

/*

*/